import { TClientProduct } from 'shared/types';
import { IKeyword } from 'types';

export type TCategory =
    | 'KEYWORD'
    | 'PRODUCT_INFO'
    | 'PRODUCT_TITLE'
    | 'USER'
    | 'COMPANY'
    | 'PICTURE'
    | 'PRODUCT_KEYWORDS'
    | 'LIST'
    | 'SECTORISATION'
    | 'KEYWORD_CATEGORIES'
    | 'COLORS'
    | 'INTERNATIONAL_COMPANY_GROUPS'
    | 'SALES_DATA';
export type TAction = 'ADD' | 'DELETE' | 'UPDATE' | 'EXPORT' | 'UPLOAD' | 'ERROR';

export type TKeywordAddChanges = {
    keyword: string;
};

export type TKeywordDeleteChanges = {
    keywords: IKeyword[];
};

export type TKeywordExportChanges = {
    type: string;
    keywords?: IKeyword[];
};

export type TColorsChanges = {
    id: number;
    name: string;
    changes: {
        color: string[];
    };
};

export type TDeleteChanges = {
    id: number;
    name: string;
};

export type TKeywordUpdateChanges = {
    oldKeywords: IKeyword[];
    newKeywords: IKeyword[];
};

export type THistoryChanges = {
    nameId?: string;
    changes?: { [key: string]: [string, string] | string };
    list?: string[];
};

export type TListChanges = {
    nameId?: string;
    changes?: { [key: string]: [string, string] | string };
    list?: string[];
    type: string;
    active: boolean;
};

export type TProductKeywordsChanges = {
    ean: string;
    keywordsChanges: {
        created: {
            keyword_id: number;
            keyword_name: string;
        }[];
        deleted: {
            keyword_id: number;
            keyword_name: string;
        }[];
        modified: {
            keyword_id: number;
            keyword_name: string;
            is_priority: boolean;
        }[];
    };
};

export type TKeywordCategoriesChanges = {
    updatedSegments: {
        id: string;
        name: string;
    }[];
    segmentsKeywords: {
        id: number;
        name: string;
    }[];
};

export type TSalesDataUploadChanges = {
    fileName: string;
    comment: string;
};

export type TProductKeywordsUploadParams = { data?: TProductKeywordsChanges[] };
export type TKeywordCategoriesUploadParams = { data?: TKeywordCategoriesChanges[] };
export type TSalesDataUploadParams = { data?: TSalesDataUploadChanges };

export type TKeywordErrorChanges = {
    keywords: IKeyword[];
};

export type TProductAddChanges = {
    ean: string;
};

export type TUserAddChanges = {
    username: string;
};

export type TProductDeleteChanges = {
    products: string[];
};

export type TProductUpdateChanges = {
    oldProducts: TClientProduct[];
    newProducts: TClientProduct[];
};

export type TFacUpdateChanges = {
    oldFac: number[];
    newFac: number[];
};

export type TProductUploadChanges = {
    created: TClientProduct[];
    updated: TProductUpdateChanges;
    notAccepted: any[];
    deleted: TClientProduct[];
};

export type TListAddChanges = {
    list: string;
};

export type TListDeleteChanges = {
    list: string;
};

export type TListUpdateChanges = {
    listDiff: string[];
};

export interface IInternationalCompanyGroupsUpdateChanges {
    id: number;
    name?: {
        old?: string;
        new?: string;
    };
    international_company?: {
        old?: {
            id: number;
            name: string;
        };
        new?: {
            id: number;
            name: string;
        };
    };
    users?: {
        added?: {
            id: number;
            username: string;
        }[];
        deleted?: {
            id: number;
            username: string;
        }[];
    };
    company_groups?: {
        added?: {
            id: number;
            name: string;
            company_id: number;
            company_name: string;
        }[];
        deleted?: {
            company_id: number;
            company_name: string;
            int_company_groups_ids: number[];
            id: number;
            name: string;
        }[];
    };
}
export interface IInternationalCompanyGroupsAddChanges {
    id: number;
    name: string;
    international_company: {
        id: number;
        name: string;
    };
    users: {
        id: number;
        username: string;
    }[];
    company_groups: {
        id: number;
        name: string;
    }[];
}

export type TParamsType = {
    KEYWORD: TKeywordAddChanges | TKeywordDeleteChanges | TKeywordExportChanges | TKeywordUpdateChanges;
    LIST: TListAddChanges | TListDeleteChanges | TListUpdateChanges;
    PRODUCT_INFO: TProductAddChanges | TProductDeleteChanges | TProductUpdateChanges | TProductUploadChanges;
    USER: THistoryChanges;
    COMPANY: THistoryChanges;
    PRODUCT_TITLE:
        | TProductAddChanges
        | TProductDeleteChanges
        | TProductUpdateChanges
        | TProductUploadChanges
        | TFacUpdateChanges;
};
export interface IHistory<Category extends keyof TParamsType & TCategory> extends Object {
    user: string;
    category: Category;
    action: TAction;
    date: Date;
    params: TParamsType[Category];
    retailer?: string;
    lang?: string;
}

export type THistoryEntry = IHistory<'KEYWORD' | 'PRODUCT_INFO' | 'PRODUCT_TITLE'>;

export const IGNORED_COMPARED_FIELD = ['keyword_id', 'read_only', 'company_country'];
